<template>
  <div class="desk-frame contact-page">
    <div
      class="head_row_calander bg--white flex flex--content--center no_mobile"
    >
      <h1 class="title title--40 no-marge tx--blue2">
        בקשה להוספה/החלפת רכב בחניון רופאים
      </h1>
    </div>
    <menu-desktop class="no_mobile" />

    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>

    <transition name="slide">
      <div class="contact h-main bg--white m-no-bg page-edit-padd">
        <div class="before-send" v-if="!formSent">
          <ValidationObserver ref="LicensePlateForm">
            <form
              @submit.prevent="sendForm"
              autocomplete="off"
              name="LicensePlateForm"
              class="car-license-form"
            >
              <div class="car-section">
                <div class="form_input">
                  <label>האם מדובר בהחלפת רכב?*</label>
                  <validation-provider
                    name="changecar"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <select2 dir="rtl" v-model="changecar">
                      <option value="">בחר</option>
                      <option value="1">כן</option>
                      <option value="2">לא</option>
                    </select2>
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div v-if="changecar === '1'" class="car-sub-fields">
                  <div class="form_input input-38">
                    <label>מספר רכב להסרה*</label>
                    <validation-provider
                      :rules="{ required: true }"
                      name="removedcar"
                      v-slot="{ errors }"
                    >
                      <input
                        name="removedcar"
                        v-mask="'#'.repeat(8)"
                        v-model="removedcar"
                        type="text"
                        inputmode="numeric"
                      />
                      <span class="error-message" v-if="errors.length > 0">{{
                        errors[0]
                      }}</span>
                    </validation-provider>
                  </div>
                </div>

                <div class="car-sub-fields">
                  <div class="form_input input-38">
                    <label>מספר רכב חדש*</label>
                    <validation-provider
                      :rules="{ required: true }"
                      name="carlicense"
                      v-slot="{ errors }"
                    >
                      <input
                        name="carlicense"
                        v-mask="'#'.repeat(8)"
                        v-model="carlicense"
                        type="text"
                        inputmode="numeric"
                      />
                      <span class="error-message" v-if="errors.length > 0">{{
                        errors[0]
                      }}</span>
                    </validation-provider>
                  </div>
                </div>
              </div>

              <div class="car-section">
                <div class="form_input">
                  <label>הוספת רכב נוסף?</label>
                  <validation-provider name="anothercar" v-slot="{ errors }">
                    <select2 dir="rtl" v-model="anothercar">
                      <option value="">בחר</option>
                      <option value="1">כן</option>
                      <option value="2">לא</option>
                    </select2>
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div v-if="anothercar === '1'" class="car-sub-fields">
                  <div class="form_input input-38">
                    <label>מספר רכב נוסף*</label>
                    <validation-provider
                      :rules="{ required: true }"
                      name="carlicense2"
                      v-slot="{ errors }"
                    >
                      <input
                        name="carlicense2"
                        v-mask="'#'.repeat(8)"
                        v-model="carlicense2"
                        type="text"
                        inputmode="numeric"
                      />
                      <span class="error-message" v-if="errors.length > 0">{{
                        errors[0]
                      }}</span>
                    </validation-provider>
                  </div>
                </div>
              </div>

              <div class="form_submit" :class="{ bt_disable: emptyForm }">
                <input type="submit" :disabled="emptyForm" value="שליחה" />
              </div>
            </form>
          </ValidationObserver>
        </div>

        <div class="after-send m-center" v-if="formSent">
          <Thank />
          <div class="title tx--blue2">
            בקשתך נשלחה בהצלחה
          </div>
          <button class="bt_blue mt--20" @click="resetForm" type="button">
            חזרה לטופס
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import Thank from "@/assets/img/svg/thank.svg";
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import { sendCelloSignGeneric } from "../api/api-quatro";

export default {
  name: "LicensePlateForm",
  components: {
    Thank,
    Menu,
    DashboardHeader,
    MenuDesktop
  },
  computed: {
    ...mapGetters(["MENU_ACTIVE"]),
    ...mapState(["activeUser", "activeDoctor"]),
    emptyForm() {
      if (!this.changecar) return true;
      if (!this.carlicense) return true;
      if (this.changecar === "1" && !this.removedcar) return true;
      if (this.anothercar === "1" && !this.carlicense2) return true;
      return false;
    }
  },
  data() {
    return {
      formSent: false,
      changecar: "",
      removedcar: "",
      carlicense: "",
      anothercar: "",
      carlicense2: ""
    };
  },
  methods: {
    ...mapMutations(["UPDATE_MENU_STATE"]),
    async sendForm() {
      const isValid = await this.$refs.LicensePlateForm.validate();
      if (!isValid || this.emptyForm) return;

      const data = {
        heb_name: this.activeDoctor.name,
        changecar: this.changecar,
        anothercar: this.anothercar,
        carlicense: this.carlicense || "",
        carlicense2: this.carlicense2 || "",
        removedcar: this.removedcar || ""
      };

      const req = {
        url:
          "https://app.cellosign.com/api/v3/doc_app_forms/bpmn/050ac1b9-812d-41bd-bf8c-8ba809a8f92c/start/",
        template: "050ac1b9-812d-41bd-bf8c-8ba809a8f92c",
        project: "doc_app_forms",
        token: "818491cd13ea35e96654b1d79531c9b93f3019ce",
        wait_for_first_session: false,
        data
      };

      sendCelloSignGeneric(req).catch(() => {});
      this.formSent = true;
    },
    resetForm() {
      this.formSent = false;
      this.changecar = "";
      this.removedcar = "";
      this.carlicense = "";
      this.anothercar = "";
      this.carlicense2 = "";
      this.$nextTick(() => {
        this.$refs.LicensePlateForm.reset();
      });
    }
  },
  watch: {
    changecar(val) {
      if (val !== "1") {
        this.removedcar = "";
      }
    },
    anothercar(val) {
      if (val !== "1") {
        this.carlicense2 = "";
      }
    }
  },
  mounted() {
    if (this.MENU_ACTIVE) {
      this.UPDATE_MENU_STATE(false);
    }
  }
};
</script>

<style scoped>
.car-license-form {
  max-width: 500px;
  margin: 0 auto;
}
.mt--20 {
  margin-top: 20px;
}
.car-section {
  width: 100%;
  margin-bottom: 16px;
  background: #f8f9fc;
  border-radius: 3px;
  padding: 24px;
  border: 1px solid #e8ecf3;
}
.car-section .form_input {
  margin-bottom: 0;
}
.car-section .form_input label {
  position: static;
  font-size: 24px;
  font-weight: 600;
  color: #30448d;
  opacity: 1;
  padding: 0;
  margin-bottom: 10px;
  display: block;
}
.car-sub-fields {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #dde2ed;
}
.car-sub-fields .form_input {
  margin-bottom: 24px;
}
.car-sub-fields .form_input:last-child {
  margin-bottom: 0;
}
.car-license-form .form_submit {
  width: 100%;
}
.car-license-form .form_submit input {
  width: 100%;
}
</style>

<style>
.car-section .select2-container .select2-selection--single {
  height: 58px;
  line-height: 58px;
}
.car-section
  .select2-container
  .select2-selection--single
  .select2-selection__rendered {
  line-height: 58px;
  font-size: 28px;
}
.car-section
  .select2-container
  .select2-selection--single
  .select2-selection__arrow {
  height: 56px;
}
.car-section .form_input.input-38 input {
  height: 58px;
  padding-top: 0;
  font-size: 28px;
}
</style>
